import {
  matchPath,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";

import { Spinner, Stack, useTheme } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { VerticalTabs } from "@components/VerticalTabs";
import { useOpsReportsPermissionsQuery } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";

import { ReportsTabs } from "./ReportsTabs";
import { SystemEnvTabs } from "./system-env-tabs.constants";

export const SystemEnvSections: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const onSectionChange = (nextId: string) => {
    navigate(nextId);
  };

  const permissionsQuery = useOpsReportsPermissionsQuery();

  const match = matchPath("/system/env/*", location.pathname);
  const selectedTab = match?.params?.["*"];

  if (!selectedTab) {
    return <Navigate to={SystemEnvTabs.User.Manage.id} replace />;
  }

  return (
    <Stack
      tokens={{
        childrenGap: theme.spacing.m
      }}
    >
      <VerticalTabs
        title="Users"
        tabs={Object.values(SystemEnvTabs.User)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
      <VerticalTabs
        title="Roles"
        tabs={Object.values(SystemEnvTabs.Roles)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
      <VerticalTabs
        title="Events"
        tabs={Object.values(SystemEnvTabs.Events)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
      <QueryStateIndicator
        {...permissionsQuery}
        LoadingComponent={<Spinner />}
        allowNullOrUndefined
      >
        {data =>
          data ? (
            <ReportsTabs
              selectedTab={selectedTab}
              onSectionChange={onSectionChange}
            />
          ) : null
        }
      </QueryStateIndicator>
    </Stack>
  );
};
